const useCoverageOptionsLogic = () => {
  const apiRoute = "coverageoptions";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Coverage option name",
      type: "text",
      isRequired: true,
      err: "Coverage option name is required",
      disableEditForNonAdmin: true,
    },
    {
      name: "allow_frontend",
      label: "Show on frontend?",
      type: "toggle",
      isRequired: false,
      err: "Show on frontend? is required",
    },
    {
      name: "description",
      label: "Description",
      switchField: "description_mode",
      type: "richtext",
      isRequired: true,
      err: "Description is required",
      span: 1,
    },
    {
      name: "description_mode",
      label: "Description mode",
      type: "text",
      // isRequired: true,
      err: "Description mode is required",
      defaultValue: "code",
      span: 1,
      hide: true,
    },
    {
      name: "days_to_show",
      label: "Days to show on frontend",
      type: "number",
      minValue: 0,
      err: "Days to show is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [];
  };
  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    onlyForm,
    getPromises,
  };
};

export default useCoverageOptionsLogic;
